export default __webpack_public_path__ + "static/media/userBlockModal.78588df8.svg";